import React from "react";
import { Box, Typography } from "@mui/material";

const ContentInfo = ({ children, sx }) => (
	<Box
		sx={{
			mt: 2,
			borderRadius: "10px",
			backgroundColor: "#eee",
			color: "#000",
			p: 2,
			border: "none",
			...sx
		}}
	>
		<Typography variant="body2">
			{children}
		</Typography>
	</Box>
);

export default ContentInfo;
